import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

// Images/Others
import { images } from "../../imageValues";
import stringValues from "../../stringValues";
import { Board } from "../../typeOfboard";
import {
  CenterArea,
  CenterAreaOne,
  Container,
  MatchBoxStrip,
  PlayGround,
  Board as BoardView,
  MatchBoxStripArea,
  MatchBoxStripButton,
  LottieAnimation,
  Animation,
  OuterDiv,
  Button,
  ButtonImg,
} from "./SelectBoardStyled";
import { generateRandomNumber, playSound, AxlTracker } from "../../utils";
import scrollAnimation from "../../assets/lottieAnimation/ScrollArrow.json";

// Action
import { playPauseSound } from "../../actions/playPauseSoundAction";
import { changeLanguage } from "../../actions/changeLanguageAction";

//AXL
import { useAxL } from "../../AxLContext";
import AxL from "../../axl";

const SelectBoard = ({
  onClick,
  playPauseSound,
  playPauseSoundState,
  changeLanguage,
  changeLanguageState,
  getInfo,
  setInfo,
  getInstruction,
  setInstruction,
  resetGame,
}) => {
  const axl = useAxL();
  const [mobileWidth, setMobileWidth] = useState(window.innerWidth);
  const [showInfo, setShowInfo] = useState(false);
  const [showInstruction, setShowInstruction] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setMobileWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setShowInfo(setInfo);
    setShowInstruction(setInstruction);
  }, [setInfo, setInstruction]);

  // This is used to select a random board
  const randomBoard = () => {
    const value = generateRandomNumber(19, 0);
    onClick(Board[value].boardName);
    AxlTracker(axl, "Clicked on RANDOMIZE", "Random Board Selected", 22, true);
  };

  const switchLanguage = () => {
    return changeLanguageState.data === "en"
      ? changeLanguage("hi")
      : changeLanguage("en");
  };

  const AxlShare = () => {
    axl.sendMessage(AxL.ChildToHost.SHARE, {
      title: stringValues[changeLanguageState.data].buildYourOwnMatchbox,
    });
  };
  return (
    <>
      <Container>
        {mobileWidth < 1080 && (
          <OuterDiv>
            <Button
              onClick={() => {
                setShowInfo(true);
                getInfo(true);
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Information",
                  "Hide and Unhide",
                  10,
                  true
                );
              }}
              title="Information"
            >
              <ButtonImg src={images.INFORMATION} />
            </Button>
            <Button
              onClick={() => {
                // SetshowDropDownLanguage(!showDropDownLanguage);
                switchLanguage();
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Language",
                  "Language Switch",
                  9,
                  true
                );
              }}
              title="Language"
            >
              <ButtonImg src={images.LANGUAGE} />
            </Button>
            <Button
              onClick={() => {
                playPauseSound(!playPauseSoundState.data);
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Volume",
                  "Mute and Unmute",
                  13,
                  true
                );
              }}
              title="Sound"
            >
              {playPauseSoundState.data ? (
                <ButtonImg src={images.VOLUMEON} />
              ) : (
                <ButtonImg src={images.VOLUMEOOF} />
              )}
            </Button>
            <Button
              onClick={() => {
                AxlShare();
                playSound(playPauseSoundState);
                AxlTracker(axl, "Clicked on Share", "Share", 97, true);
              }}
              title="Share"
            >
              <ButtonImg src={images.SHAREBUTTON} />
            </Button>
            <Button
              onClick={() => {
                playSound(playPauseSoundState);
                setShowInstruction(true);
                getInstruction(true);
                AxlTracker(
                  axl,
                  "Clicked on Instruction",
                  "Hide and Unhide",
                  17,
                  true
                );
              }}
              title="Instructions"
            >
              <ButtonImg src={images.INSTRUCTION} />
            </Button>
            <Button
              onClick={() => {
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Restart",
                  "Game Restarts",
                  16,
                  true
                );
                resetGame();
              }}
              title="Restart"
            >
              <ButtonImg src={images.RESTART} />
            </Button>
          </OuterDiv>
        )}
        <PlayGround>
          {mobileWidth > 1080 ? (
            <MatchBoxStrip src={images.MATCHBOXSTRIP} />
          ) : (
            // <MatchBoxStripArea>
            //   <MatchBoxStrip src={images.MATCHBOXSTRIPCATEGORYTOP2} />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       playSound(playPauseSoundState);
            //       AxlTracker(
            //         axl,
            //         "Clicked on Restart",
            //         "Game Restart",
            //         16,
            //         true
            //       );
            //       resetGame();
            //     }}
            //     style={{
            //       left: 16,
            //     }}
            //     title={stringValues[changeLanguageState.data].restart}
            //   />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       playSound(playPauseSoundState);
            //       setShowInstruction(!showInstruction);
            //       getInstruction(!showInstruction);
            //       AxlTracker(
            //         axl,
            //         "Clicked on Instruction",
            //         "Hide and Unhide",
            //         17,
            //         true
            //       );
            //     }}
            //     style={{
            //       left: 138,
            //     }}
            //     title={stringValues[changeLanguageState.data].instruction}
            //   />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       setShowInfo(!showInfo);
            //       getInfo(!showInfo);
            //       playSound(playPauseSoundState);
            //       AxlTracker(
            //         axl,
            //         "Clicked on Information",
            //         "Hide and Unhide",
            //         10,
            //         true
            //       );
            //     }}
            //     style={{
            //       right: 80,
            //     }}
            //     title={stringValues[changeLanguageState.data].info}
            //   />
            // </MatchBoxStripArea>
            <MatchBoxStrip src={images.MATCHBOXSTRIP} />
          )}
          <CenterArea>
            <h3
              style={{
                color: "orange",
                marginTop: 800,
                textAlign: "center",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              {stringValues[changeLanguageState.data].selectBoardTitle}
            </h3>
            <CenterAreaOne>
              {Board.map((data, key) => {
                return (
                  <BoardView
                    key={key}
                    onClick={() => {
                      onClick(data.boardName);
                      playSound(playPauseSoundState);
                      AxlTracker(
                        axl,
                        "Clicked on 1 out of 18 Boards ",
                        `User Selects ${data.boardName} Board`,
                        19,
                        true
                      );
                    }}
                  >
                    <img
                      src={data.boardImage}
                      style={{
                        objectFit: "contain",
                        width: 115,
                        height: 130,
                        marginBottom: 10,
                      }}
                      alt="BoardImages"
                    />
                    <span style={{ color: "orange", fontSize: 13 }}>
                      {changeLanguageState.data == "en"
                        ? data.boardName
                        : data.boardNameHi}
                    </span>
                  </BoardView>
                );
              }, [])}
            </CenterAreaOne>
            <Animation>
              <LottieAnimation
                animationData={scrollAnimation}
                style={{
                  width: 40,
                  height: 40,
                }}
              />
            </Animation>
            {/* {showDropDownLanguage && DropdownLanguageView()} */}
          </CenterArea>
          {mobileWidth > 1080 ? (
            <MatchBoxStripArea>
              <MatchBoxStrip src={images.MATCHBOXSTRIP} />
              {/* <button
              onClick={randomBoard}
              style={{
                cursor: "pointer",
                position: "absolute",
                backgroundColor: "orange",
                padding: 10,
                paddingTop: 12,
                borderRadius: 10,
                left: 110,
                border: 0,
              }}
            >
              <span style={{ color: "brown", fontSize: 17, fontWeight: 700 }}>
                R A N D O M I Z E
              </span>
            </button> */}
            </MatchBoxStripArea>
          ) : (
            // <MatchBoxStripArea>
            //   <MatchBoxStrip
            //     src={
            //       playPauseSoundState.data
            //         ? images.MATCHBOXSTRIPAUDIOONSHARELANGUAGE
            //         : images.MATCHBOXSTRIPAUDIOOFFSHARELANGUAGE
            //     }
            //   />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       // SetshowDropDownLanguage(!showDropDownLanguage);
            //       switchLanguage();
            //       playSound(playPauseSoundState);
            //       AxlTracker(
            //         axl,
            //         "Clicked on Language",
            //         "Language Switch",
            //         20,
            //         true
            //       );
            //     }}
            //     style={{
            //       left: 14,
            //     }}
            //     title={stringValues[changeLanguageState.data].language}
            //   />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       AxlShare();
            //       playSound(playPauseSoundState);
            //       AxlTracker(axl, "Clicked on Share", "Share", 97, true);
            //     }}
            //     style={{
            //       right: 174,
            //     }}
            //     title={stringValues[changeLanguageState.data].share}
            //   />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       playPauseSound(!playPauseSoundState.data);
            //       playSound(playPauseSoundState);
            //       AxlTracker(
            //         axl,
            //         "Clicked on Volume",
            //         "Mute and Unmute",
            //         11,
            //         true
            //       );
            //     }}
            //     style={{
            //       marginRight: 15,
            //     }}
            //     title={stringValues[changeLanguageState.data].sound}
            //   />
            // </MatchBoxStripArea>
            <MatchBoxStrip src={images.MATCHBOXSTRIP} />
          )}
        </PlayGround>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  playPauseSoundState: state.playPauseSound,
  changeLanguageState: state.changeLanguage,
});

const mapDispatchToProps = (dispatch) => ({
  playPauseSound: (params) => dispatch(playPauseSound(params)),
  changeLanguage: (params) => dispatch(changeLanguage(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectBoard);
